import React from 'react';

import GalleryComponent from '../../gallery/Gallery';

import GalleryImages from '../../../assets/gallery/galleryImages';


class Gallery extends React.Component {
  render() {
    return <GalleryComponent images={GalleryImages}/>;
  }
}

export default Gallery;
